import { createStyles } from '@material-ui/core/styles';

export default createStyles({
  root: {
    '&.MuiCheckbox-root .MuiIconButton-label > svg': {
      width: 24,
      height: 24,
    },
    '&.MuiMenuItem-root, .MuiMenu-paper': {
      background: 'green',
    },
  },
});
